<template>
  <transition-group name="fade">
    <section
      v-if="!open"
      :key="microButton.ref + 'button'"
      class="micro-button"
      :style="{
        top: microButton.position.top + '%',
        left: microButton.position.left + '%'
      }"
      @click="playAnimation"
    ></section>
    <section
      v-if="open"
      :key="microButton.ref + 'textbox'"
      class="text-box active"
      :style="{
        top: microButton.position.top - 5+ '%',
        left: microButton.position.left - setTextboxLeftPosition() + '%'
      }"
    >
      <div class="text-box__text-area">
        <div class="text-box__text-area__wrapper">
          <div class="font text-box__text-area__wrapper__text 'full-width'">
            <p id="textBoxText" v-html="microButton.text"></p>
          </div>
        </div>
      </div>

      <div class="text-box__next-area"></div>
      <div
        class="text-box__pointer-area"
        :class="{
          'arrow-left':
            microButton.arrowPosition !== 'center' &&
            microButton.arrowPosition !== 'right',
          'arrow-center': microButton.arrowPosition === 'center',
          'arrow-right': microButton.arrowPosition === 'right'
        }"
      >
        <div
          class="arrow-down"
          :class="{
            'arrow-left-margin':
              microButton.arrowPosition !== 'center' &&
              microButton.arrowPosition !== 'right',
            'arrow-right-margin': microButton.arrowPosition === 'right'
          }"
        ></div>
      </div>
    </section>
  </transition-group>
</template>

<script>
import MicroTextbox from "./StoryTextBox";
import { mapState, mapActions } from "vuex";
export default {
  name: "micro-button",
  components: {
    MicroTextbox
  },
  props: ["microButton", "playMicroAnimation", "appIsIdle"],
  data() {
    return {
      open: false,
      showText: false
    };
  },
  methods: {
    ...mapActions(["findMicroAnimation", "removeMicroAnimation"]),
    setTextboxLeftPosition() {
      if (this.microButton.arrowPosition === "center") {
        return 4.9;
      } else if (this.microButton.arrowPosition === "right") {
        return 9.1;
      } else {
        return 0.6;
      }
    },
    playAnimation() {
      this.$ga.event({
        eventCategory: "Micro Animation",
        eventAction: "Play",
        eventLabel: this.microButton.ref,
        eventValue: 1
      });
      this.open = true;
      this.findMicroAnimation(this.microButton.id);
      setTimeout(() => {
        this.showText = false;
        this.open = false;
        this.removeMicroAnimation(this.microButton.id);
      }, this.microButton.buttonDelay);
    }
  }
};
</script>

<style scoped lang="scss">
@import "../styles/_vars";

$button-effect-size: 280%;
.micro-button {
  position: absolute;
  width: 0.75vw;
  height: 0.75vw;
  border-radius: 50%;
  top: 50%;
  left: 52.5%;
  z-index: 101;
  cursor: pointer;
  &::before {
    content: "";
    display: block;
    width: $button-effect-size;
    height: $button-effect-size;
    position: absolute;
    top: -#{($button-effect-size - 100%) / 2};
    left: -#{($button-effect-size - 100%) / 2};
    background: radial-gradient(
      rgba(#fff, 0) 50%,
      rgba(#fff, 0.7) 51%,
      rgba(#fff, 0) 53%
    );
    animation-duration: 4s;
    animation-name: pulseCircle;
    animation-iteration-count: infinite;
    animation-timing-function: cubic-bezier(0.06, 0.25, 0.38, 1.07);
  }

  &::after {
    content: "";
    display: block;
    width: $button-effect-size;
    height: $button-effect-size;
    position: absolute;
    top: -#{($button-effect-size - 100%) / 2};
    left: -#{($button-effect-size - 100%) / 2};
    background: radial-gradient(rgba(#b8fdad, 0.5), rgba(#b8fdad, 0) 75%);
    border-radius: 100%;
    animation-duration: 4s;
    animation-name: pulseGradient;
    animation-iteration-count: infinite;
    animation-timing-function: cubic-bezier(0.12, 0.32, 0.08, -0.26);
  }

  background: url("../assets/text-box-accents/yellow-icon-i.svg") no-repeat;
}

.text-box {
  opacity: 1;
  position: fixed;
  width: 10.5vw;
  height: 4.1vw;
  transform: translateY(0%);
  &__exit-area {
    position: relative;
    display: flex;
    justify-content: flex-end;
    width: 100%;
    height: 20%;
    &__text-box-button {
      cursor: pointer;
      height: 100%;
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      justify-content: flex-end;
      align-content: center;
      align-items: center;
      &__exit {
        color: $color-white;
        font-size: 0.4vw;
        margin-right: 0.3vw;
      }
      &__icon {
        height: 0.55vw;
        width: 0.55vw;
        margin-right: 0.3vw;
      }
    }
  }
  &__text-area {
    position: relative;
    width: 100%;
    height: 46%;
    background-color: $color-white;
    &__wrapper {
      position: relative;
      width: 100%;
      height: 100%;
      padding: 2%;
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      justify-content: flex-start;
      align-content: center;
      align-items: center;
      &__icon {
        width: 16%;
        height: 100%;
        margin-top: 2%;
        margin-left: 1%;
        img {
          width: 100%;
          height: 100%;
        }
      }
      &__text {
        padding: 0.3% 0;
        width: 81%;
        height: 100%;
        line-height: 0.4vw;
        font-size: 0.3vw;
        margin-left: 2%;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        justify-content: flex-start;
        align-content: center;
        align-items: center;
      }
    }
  }
  &__progress-bar {
    position: relative;
    width: 100%;
    height: 3%;
    background-color: $color-blue;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: center;
    align-content: center;
    align-items: center;
    &__animation-progress {
      width: 100%;
      height: 100%;
      &__progress {
        height: 100%;
        width: 100%;
        background-color: $color-lime;
        transform-origin: left;
        transform: scaleX(0);
      }
    }
  }
  &__next-area {
    height: 19%;
    display: flex;
    justify-content: flex-end;
    background-color: $color-black-transparent;
    &__text-box-button {
      cursor: pointer;
      height: 100%;
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      justify-content: flex-end;
      align-content: center;
      align-items: center;
      &__next {
        color: $color-lime-bright;
        font-size: 0.4vw;
        margin-right: 0.3vw;
      }
      &__icon {
        height: 0.55vw;
        width: 0.55vw;
        margin-right: 0.3vw;
      }
    }
  }
  &__pointer-area {
    position: relative;
    width: 100%;
    height: 10%;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
  }
}

.arrow-down {
  width: 0;
  height: 0;
  border-left: 0.5vw solid transparent;
  border-right: 0.5vw solid transparent;
  border-top: 0.4vw solid rgba(black, 0.5);
}
.arrow-left {
  justify-content: flex-start;
}
.arrow-left-margin {
  margin-left: 0.5vw;
}
.arrow-center {
  justify-content: center;
}
.arrow-right {
  justify-content: flex-end;
}

.arrow-right-margin {
  margin-right: 0.5vw;
}
.active {
  z-index: 200;
}

.full-width {
  width: 100%;
}

.fade-enter-active {
  transition: opacity $micro-transition-duration
      cubic-bezier(0.64, 0.03, 0.07, 0.97),
    transform $micro-transition-duration cubic-bezier(0.64, 0.03, 0.07, 0.97);
}
.fade-enter {
  opacity: 0;
  transform: translate(0%, 50%);
}
.fade-leave-active {
  transition: opacity $micro-transition-duration cubic-bezier(0.22, 1, 0.36, 1),
    transform $micro-transition-duration cubic-bezier(0.22, 1, 0.36, 1);
}
.fade-leave-to {
  opacity: 0;
  transform: translate(0%, 50%);
}
</style>
